export const TopInfoCard = () => (
    <div className="card mb-3">
        <div className="card-body py-2 text-center">
            <p className="mb-0 text-gradient text-dark">
                Tradesperson is on site
            </p>
        </div>
    </div>
);